'use strict';

import firebase from 'firebase/app';
import 'firebase/auth';
import JWT from '../services/jwt/JWT';

export default function auth({ next, router }) {
    // Check if the JWT has expired and if so refresh it
    JWT.verify();

    firebase.auth().onAuthStateChanged(user => {
        return !user ? next('/login') : next();
    });
}